var _excluded = ["showIcon", "currency", "placeholder", "size", "onChange", "allowNegativeValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { forwardRef } from 'react';
import { Group } from '../../../containers';
import { useIntl } from '../../../theme/i18n';
import { defaultCurrency, getCurrencyDetails } from '../../../utils/currency-utils';
import { FlagIcon, Text } from '../../dataDisplay';
import { _CurrencyInput } from '../../internal/_CurrencyInput';
import { TextField } from '../TextField';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AmountField = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    formatCurrency
  } = useIntl();

  var {
    showIcon = false,
    currency = defaultCurrency,
    placeholder = formatCurrency(0, currency),
    size = 'large',
    onChange,
    allowNegativeValue = true
  } = props,
      inputProps = _objectWithoutProperties(props, _excluded);

  var {
    icon
  } = getCurrencyDetails(currency);
  var rightElement = showIcon && !props.isViewMode ? /*#__PURE__*/_jsxs(Group, {
    spacing: "xxs",
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FlagIcon, {
      type: icon,
      size: "small",
      isDisabled: props.isDisabled
    }), /*#__PURE__*/_jsx(Text, {
      textStyle: "body2",
      color: props.isDisabled ? 'neutral.light' : 'neutral.darkest',
      children: currency
    })]
  }) : undefined;
  return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({
    "data-component": "AmountField",
    ref: ref,
    as: _CurrencyInput
  }, inputProps), {}, {
    allowNegativeValue: allowNegativeValue,
    placeholder: placeholder,
    size: size,
    rightElement: rightElement,
    currency: currency,
    onValueChange: value => {
      onChange === null || onChange === void 0 ? void 0 : onChange({
        target: {
          value: value !== null && value !== void 0 ? value : ''
        }
      });
    }
  }));
});
AmountField.displayName = 'AmountField';
//# sourceMappingURL=AmountField.js.map